import { http } from "./http.js";

async function getNotifications() {
  const result = await http.get("notifications");
  return result.data.map((i) => {
    return {
      date: i.Date,
      id: i.Id,
      isReaded: i.IsReaded,
      message: i.Message,
      payload: i.Payload
        ? {
          client: i.Client
            ? { id: i.Client.Id, title: i.Client.Title }
            : null,
          sender: i.Sender,
          driver: i.Payload.Driver
            ? {
              id: i.Payload.Driver.Id,
              title: i.Payload.Driver.Title,
              phones: i.Payload.Driver.Phones,
              viber: i.Payload.Driver.Viber,
            }
            : null,
          factory: i.Payload.Factory
            ? { id: i.Payload.Factory.Id, title: i.Payload.Factory.Title }
            : null,
          files: i.Payload.Files?.length
            ? i.Payload.Files.map((file) => ({
              id: file.Id,
              originName: file.OriginName,
              path: file.Path,
            }))
            : [],
          route: i.Payload.Route
            ? { id: i.Payload.Route.Id, title: i.Payload.Route.Title }
            : null,
          shipping: i.Payload.Shipping
            ? { id: i.Payload.Shipping.Id, title: i.Payload.Shipping.Title }
            : null,
        }
        : null,
      readedDate: i.ReadedDate,
      type: i.Type,
    };
  });
}

async function changeNotificationState(notification) {
  const result = await http.patch(
    `notifications/${notification.id}/is-readed`,
    {
      value: notification.isReaded,
    }
  );
  return result;
}

export { getNotifications, changeNotificationState };
